import getTrialDueDate from '#shared/util/getTrialDueDate.js';
import isObject from '#shared/util/isObject.js';

import cSkeleton from '#themes/default/default/components/skeleton/skeleton.js';
import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './priceTable.html' with { type: 'html' };

export default {
	name: 'CPriceTable',
	components: {
		cSkeleton,
		cSvg
	},
	props: {
		form: {
			type: Object,
			default: () => null
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isNewMethod: {
			type: Boolean,
			default: false
		},
		isSidebar: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		isEmpty() {
			return this.$store.state.isEmpty;
		},
		trialDueDate() {
			return getTrialDueDate(this.order, this.theme, this.isThankYouPage);
		},
		isConfirmOrderPage() {
			return isObject(this.page) && this.page.number === 3;
		},
		firstProduct() {
			return this.order.products.length ? this.order.products[0] : null;
		},
		isBrazilianFlow() {
			return this.order?.isBrazilianFlow;
		},
		hasInstallments() {
			return this.isBrazilianFlow && (this.selectedPayment.id === 'creditCard' || this.payment.type === 'creditCard');
		},
		installmentsPrice() {
			const installmentsEntries = this.order.price.installments;
			const numberOfInstallments = this.form.installments;
			const [, installmentsPrice] = installmentsEntries.find(([installments]) => installments === numberOfInstallments) || [];
			return installmentsPrice?.formatted ?? '';
		},
		totalPrice() {
			// Display /year (or /first year) for en-us cart, required by T&Cs
			let yearNote = '';
			if (this.order.hasYearNote) {
				// For single product with yearsValidity show correct years
				if (this.order.productsCount === 1) {
					const firstProduct = this.order.products[0];
					if (!this.order.hasDiscount && firstProduct.yearsValidity === 1) {
						// Show "/year" for the full-price 1-year products
						yearNote = this.t('cart_year');
					} else if (firstProduct.yearsValidity >= 1) {
						// Show "/first X year/years" for 1+ years product variants no matter the price (discount or full-price)
						yearNote = this.t('cart_productFirstYear', {
							validity: firstProduct.yearsValidity,
							additional: ''
						});
					} else if (firstProduct.monthsValidity < 12) {
						// Show "/X months" or "/first X months" variant
						yearNote = this.t(this.order.hasDiscount ? 'cart_productFirstMonth' : 'cart_productMonth', {
							validity: firstProduct.monthsValidity,
							additional: ''
						});
					}
				} else {
					// For multi-product orders with different validity periods
					if (this.order.products.every((product) => product.monthsValidity >= 12)) {
						yearNote = this.order.hasDiscount ? this.t('cart_firstYear') : this.t('cart_year');
					} else {
						// Show no year note for the rest of the products mix of yearly and monthly products
						yearNote = '';
					}
				}
			}
			const streetPrice = `${this.order.price.street.formatted} ${yearNote}`;
			const orderTotal = `${this.order.price.total.formatted} ${yearNote}`;
			return this.page.number === 0 && (this.order.isGuest || this.isNewMethod) && !this.theme.variables.isTaxIncluded ? streetPrice : orderTotal;
		}
	},
	template
};
